

import './auth/auth-module';
import './dashboard/dashboard-module';
import './guestlists/guestlists-module';
import './contacts/contacts-module';
import './categories/categories-module';
// import './tickets/tickets-module';
import './picklists/picklists-module';
import './seatplans/seatplans-module';
import './settings/settings-module';
import './toolbox/toolbox-module';
import './queue/queue-module';
import './statistics/statistics-module';
import './documents/documents-module';
import './downloads/downloads-routes';
import './billing/billing-module';
import './shippings/shippings-module';
import './vouchers/vouchers-module';
import './exports/exports-module';
import '../modules/bo/bo-module';

angular.module('festzelt-os.pages', [
    'festzelt-os.auth',
    'festzelt-os.dashboard',
    'festzelt-os.guestlists',
    'festzelt-os.contacts',
    'festzelt-os.categories',
    'festzelt-os.picklists',
    'festzelt-os.seatplans',
    'festzelt-os.settings',
    'festzelt-os.toolbox',
    'festzelt-os.queue',
    'festzelt-os.statistics',
    'festzelt-os.documents',
    'festzelt-os.downloads',
    'festzelt-os.billing',
    'festzelt-os.shippings',
    'festzelt-os.vouchers',
    'festzelt-os.exports',
    'festzelt-os.modules.bo'
]);

require('./pages-routes.js');



// WEBPACK FOOTER //
// ./src/app/pages/pages-module.js